import React, { useState } from 'react';
import SplashScreen from './components/SplashScreen/SplashScreen';
import Navbar from './components/Navbar/Navbar';
import Hero from './components/Hero/Hero';
import Stats from './components/Stats/Stats';
import AIDemo from './components/AIDemo/AIDemo';
import Solutions from './components/Solutions/Solutions';
import Team from './components/Team/Team';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import ScrollReveal from './components/shared/ScrollReveal';
import './App.css';

function App() {
  const [splashDone, setSplashDone] = useState(false);

  return (
    <div className="App">
      {!splashDone && <SplashScreen onComplete={() => setSplashDone(true)} />}
      <Navbar />
      <Hero />
      <ScrollReveal>
        <AIDemo />
      </ScrollReveal>
      <ScrollReveal>
        <Stats />
      </ScrollReveal>
      <ScrollReveal>
        <Solutions />
      </ScrollReveal>
      <ScrollReveal>
        <Team />
      </ScrollReveal>
      <ScrollReveal>
        <Contact />
      </ScrollReveal>
      <Footer />
      <ScrollToTop />
    </div>
  );
}

export default App;
